import { TRule } from '../../typings';
import { EDI_WHEEL_B2_PRICELIST_RULESET } from '../edi-b2/pricelist';

export const BRIDGESTONE_PRICELIST_RULESET: TRule[] = [
  ...EDI_WHEEL_B2_PRICELIST_RULESET,
];